export default __webpack_public_path__ + "assets/62d081.svg";